export default "__VITE_ASSET__B$jKuQHt__"